import { render } from "./QuickRangeButtons.vue?vue&type=template&id=28443a12&scoped=true&ts=true"
import script from "./QuickRangeButtons.vue?vue&type=script&lang=ts"
export * from "./QuickRangeButtons.vue?vue&type=script&lang=ts"

import "@/assets/scss/quick-range-buttons.scss?vue&type=style&index=0&id=28443a12&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28443a12"]])

export default __exports__